import axios from "@/util/axios";

export default {
  namespaced: true,
  state () {
    return {
      user: JSON.parse(localStorage.getItem('admin'))|| null,
      userInfo: null,
      permissions: []
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setAbility(state, payload) {
      state.permissions = payload
    },
  },
  actions: {
    login({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/login', payload).then((response) => {
          let user = response.data.data;
          commit('setUser', user);
          localStorage.setItem('admin', JSON.stringify(user));

          axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;

          resolve(user);
        }).catch((error) => {
          reject(error.response.data)
        });
      });
    },
    logout({commit}) {
      commit('setUser', null);
      localStorage.removeItem('admin');
      axios.defaults.headers.common['Authorization'] = null;
    },
    userInfo({commit}, payload) {
      commit('setUserInfo', payload);
    },
    async getPermissions({commit}){
      await axios.get('/abilities')
          .then(({ data }) => {
            commit('setAbility', data)
          })
    }
  },
  getters: {
    getUser: (state) => state.user,
    getUserInfo: (state) => state.userInfo,
    permissionList: (state) => state.permissions
  }
}